import React, { useEffect, useRef, useState } from "react";
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../subject.css';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { getEnvUrl, handleFileValidation } from "../../../../utils/Api";
import { createSubject, updateSubject, getSubjectByID } from "../../../../Services/Subjects/SubjectServices";

const CreateEditSubject = ({ isShow, close, type, subjectId }) => {
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [subjectIcon, setSubjectIcon] = useState(null);
  const [preview, setPreview] = useState(null);
  const [subjectNameError, setSubjectNameError] = useState(false);
  const [iconError, setIconError] = useState(false);
  const subjectNameRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    setShow(isShow);
    if (type === "EDIT" && subjectId) {
      fetchSubjectDetails();
    }
  }, [isShow, type, subjectId]);

  const fetchSubjectDetails = async () => {
    try {
      const response = await getSubjectByID(subjectId);
      if (response?.status) {
        setSubjectName(response.data.name || "");
        // setPreview(`${getEnvUrl()}/subject/getSubjecticon?id=${response.data.id}`);  
      } else {
        toast.error("Failed to fetch subject details");
      }
    } catch (error) {
      console.error("Error fetching subject details:", error);
    }
  };

  const handleSubmit = async () => {
    if (type === "CREATE") {
      if (!subjectName.trim() || !subjectIcon) {
        setSubjectNameError(!subjectName.trim());
        setIconError(!subjectIcon);

        let object = [
          { key: subjectName.trim(), ref: subjectNameRef.current },
          { key: subjectIcon, ref: iconRef.current },
        ];

        for (let i = 0; i < object.length; i++) {
          if (!object[i].key) {
            object[i].ref.focus();
            break;
          }
        }
        return;
      }
    }
        if (type === "EDIT") {
      if (!subjectName.trim() ) {
        setSubjectNameError(!subjectName.trim());

        let object = [
          { key: subjectName.trim(), ref: subjectNameRef.current },
        ];

        for (let i = 0; i < object.length; i++) {
          if (!object[i].key) {
            object[i].ref.focus();
            break;
          }
        }
        return;
      }
    }
    setIsLoading(true);
    setIsDisabled(true);

    const formData = new FormData();
    formData.append('name', subjectName.trim());
    if (subjectIcon) {
      formData.append('subject_icon', subjectIcon);
    }

    try {
      let response;
      if (type === "CREATE") {
        response = await createSubject(formData);
      } else {
        formData.append('game_subject_id', subjectId);
        response = await updateSubject(formData);
      }

      if (response.status) {
        toast.success(response.message);
        close();
      } else {
        toast.error(response.errorMessage);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  const handleFileChange = (e) => handleFileValidation(e, setSubjectIcon,setIconError);


  return (
    <Modal show={show} onHide={() => close(false)}>
      <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add Subject" : "Edit Subject"}</h5>
      </Modal.Header>
      <Modal.Body>
        <form className="row g-3">
          <div className="col-12 px-3">
            <label htmlFor="subjectName" className="form-label required">Name</label>
            <input
              id='subjectName'
              ref={subjectNameRef}
              maxLength={35}
              value={subjectName}
              onChange={(e) => {
                setSubjectName(e.target.value);
                if (subjectNameError && e.target.value.trim() !== '') {
                  setSubjectNameError(false);
                }
              }}
              type="text"
              className="form-control"
              placeholder="Enter Subject Name"
            />
            <Form.Control.Feedback type="invalid" style={{ display: subjectNameError ? 'block' : 'none' }}>
              Subject name is required
            </Form.Control.Feedback>
          </div>
          <div className="col-12 px-3">
            <label htmlFor="imageFile" className="form-label required">Select Subject Icon</label>
            <input
              type="file"
              className="form-control"
              id="imageFile"
              accept="image/*"
              onChange={handleFileChange}
              ref={iconRef}
            />
            <Form.Control.Feedback type="invalid" style={{ display: iconError ? 'block' : 'none' }}>
              Subject Icon is required
            </Form.Control.Feedback>
            {/* {preview && (
              <div className="mt-3">
                <p>Thumbnail Preview:</p>
                <img src={preview} alt="Selected thumbnail" className="img-thumbnail" style={{ maxWidth: '80%' }} />
              </div>
            )} */}
          </div>
          {isLoading && <div className="progress-bar"></div>}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={() => close(false)}
            >
              Close
            </button>
            <button
              disabled={isDisabled}
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {type === "CREATE" ? "Save" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateEditSubject;
